import { render, staticRenderFns } from "./SurveysubjectListAddNew.vue?vue&type=template&id=b55760e8&scoped=true&"
import script from "./SurveysubjectListAddNew.vue?vue&type=script&lang=js&"
export * from "./SurveysubjectListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./SurveysubjectListAddNew.vue?vue&type=style&index=0&id=b55760e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55760e8",
  null
  
)

export default component.exports